/**
 * The deputy column of a column-map grid (TABLE_COLUMNS_TYPES.DEPUTY_SELECT): whether the
 * approver stands in as a deputy. Shared by its filter (AppDataGridFilter.component) and its cell
 * (appDataGrid.function), which import each other's module otherwise only one way.
 */

/** The deputy filter's two options, as the backend reads them. */
export const DEPUTY_OPTIONS = ['true', 'false'];

/** What the column shows for a value, and the filter for an option - as a translation key. */
export const deputyCaption = (value: unknown) => String(value) === 'true' ? 'popUp.yes' : 'popUp.no';
